module.exports = __webpack_public_path__ + "img/bg_avatar_male_12.e2c9647c.png";